// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"a1fe6c6bc2a05a4694f7","691":"c7b6ac8853401805149c"}[chunkId] + ".js";
};